var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 17",
  fill: "none",
  stroke: "#282b67",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15
}))), _text || (_text = /*#__PURE__*/React.createElement("text", {
  transform: "translate(13.5 23)",
  fill: "#282b67",
  fontSize: 20,
  fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "i"))));
export { SvgInfoIcon as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'%3e %3cg id='info-icon' transform='translate(-948 -530)'%3e %3cg id='Ellipse_17' data-name='Ellipse 17' transform='translate(948 530)' fill='none' stroke='%23282b67' stroke-width='2'%3e %3ccircle cx='16' cy='16' r='16' stroke='none'/%3e %3ccircle cx='16' cy='16' r='15' fill='none'/%3e %3c/g%3e %3ctext id='i' transform='translate(961.5 553)' fill='%23282b67' font-size='20' font-family='HelveticaNeue-Bold, Helvetica Neue' font-weight='700'%3e%3ctspan x='0' y='0'%3ei%3c/tspan%3e%3c/text%3e %3c/g%3e %3c/svg%3e";